"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ukraineTranslations = void 0;
var _types = require("../../../types");
const ukraineTranslations = exports.ukraineTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Нам дуже шкода!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Назад',
  [_types.ErrorPageTranslationKey.text]: 'Ця сторінка на даний час недоступна',
  [_types.ErrorPageTranslationKey.notFound]: 'Нам дуже шкода, але ця сторінка недоступна',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Сторінка, яку ви намагаєтеся відкрити, обмежена, і не всі критерії виконано.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: "Будь ласка, зв'яжіться зі службою підтримки Oriflame електронною поштою:",
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Запитану URL-адресу відхилено!'
};
